import _ from 'lodash'
import useRedux from '../../utils/use_redux'
import * as actions from '../actions'

const useUser = (path, fn) => useRedux('user', actions, path, fn)

export default useUser
